module.exports = __webpack_public_path__ + "media/images/footer-4838f6719af2308558b2f85cdde89bb9.png";